import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useFeatureFlag } from '@webapp/hooks'
import { useProcurifyIntl } from '@webapp/hooks'
import { messages } from './messages'

interface UseIsStripeSunsetResult {
  isStripeSunset: boolean
  stripeSunsetHelperText: string
}

/**
 * Returns whether Stripe spending card actions should be disabled,
 * along with a helper text string for tooltips/disabled states.
 *
 * Condition: LD flag is ON, domain has stripe_integration but NOT enable_airwallex_issuing.
 */
export const useIsStripeSunset = (): UseIsStripeSunsetResult => {
  const intl = useProcurifyIntl()
  const isStripeSunsetFlagEnabled = useFeatureFlag(
    'PAY_3736_DISABLE_STRIPE_SPEND_CARD'
  )
  const { stripe_integration, enable_airwallex_issuing } = useSelector(
    makeSelectFeatureSwitches()
  )

  const isStripeSunset =
    isStripeSunsetFlagEnabled && stripe_integration && !enable_airwallex_issuing

  return {
    isStripeSunset,
    stripeSunsetHelperText: intl.formatMessage(messages.stripeSunsetHelperText),
  }
}
